import { EventEmitter } from '@angular/core';
import * as i0 from "@angular/core";
var SessionService = /** @class */ (function () {
    function SessionService() {
        // Set agent Status
        this.setOffline = new EventEmitter();
        // Change company.
        this.changeCompany = new EventEmitter();
    }
    SessionService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SessionService_Factory() { return new SessionService(); }, token: SessionService, providedIn: "root" });
    return SessionService;
}());
export { SessionService };
